import TotalEarningTable from './Table';
import styles from './index.module.scss';

type TotalEarningProps = {
	selectedPayrollId: string;
	onlyView: boolean;
	headerData: any;
	setIsUniversalLoading: any;
	payPeriodId: any;
	year: number;
	showSteps: boolean;
};
const TotalEarningComponent = (props: TotalEarningProps) => {
	const {
		selectedPayrollId,
		onlyView,
		headerData,
		setIsUniversalLoading,
		payPeriodId,
		year,
		showSteps,
	} = props;

	return (
		<div className={styles['total-earning__table']}>
			<TotalEarningTable
				selectedPayrollId={selectedPayrollId}
				onlyView={onlyView}
				setIsUniversalLoading={setIsUniversalLoading}
				headerData={headerData}
				payPeriodId={payPeriodId}
				year={year}
				showSteps={showSteps}
			/>
		</div>
	);
};

export default TotalEarningComponent;
